import(/* webpackMode: "eager" */ "/Users/benward/Code/marsification/src/components/NavigationMenu/NavigationMenu.tsx")